const linkTag = document.querySelector("link[href]");
const hrefValue = (linkTag && linkTag.getAttribute("href")) || "";
const index = hrefValue.lastIndexOf("/static/css/main.css");
const before = hrefValue.substring(0, index);

export const imageBaseURL = before;
